/*****************************************************************************************
 * 설명 : 페이지 라우팅
 * 작성자 :
 * 작성일 :
*****************************************************************************************/
import React, { Suspense, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';

import { IndicatorContext } from 'config/indicator';

import 'assets/css/print.scss';

import AdminLogin from "pages/admin/login/login";

import MenuList from './admin/cms/contents/menuList';
import Module from './admin/cms/module';
import Site from './admin/cms/site';
import Auth from './admin/system/auth';
import AuthGroup from './admin/system/authGroup';

// 홈페이지

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
const SiteRouter = (props) => {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
  const { setIndicator } = useContext(IndicatorContext);

  const menuList = useSelector(state => state?.menuList);
  const [moduleList, setModuleList] = useState([]);

  /***************************************************************************************
   * 설명 : 모듈 컴포넌트 로딩
  ***************************************************************************************/
  useEffect(() => {
    if( menuList.list && menuList.list.length > 0 ) {
      let module = [];

      menuList.list.forEach((menu) => {
        if( menu.modulePath && menu.modulePath !== null ) {
          const SomeComponent = React.lazy(() => import(`${menu.modulePath}`));

          module.push({
            linkUrl: menu.linkUrl,
            isRouter: menu.isRouter,
            moduleName: menu.moduleName,
            modulePath: menu.modulePath,
            module: SomeComponent
          });
        }
      });

      setModuleList(module);
    }

    // eslint-disable-next-line
  }, [menuList]);

  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  return (
    <Suspense fallback={() => setIndicator(true)}>
      <Routes>
        <Route exact="true" path="/admin" element={<AdminLogin indicator={props.indicator} history={props.history} />}></Route>
        <Route exact="true" path="/admin/login" element={<AdminLogin indicator={props.indicator} history={props.history} />}></Route>

        <Route exact="true" path="/admin/system/site" element={<Site indicator={props.indicator} history={props.history} />}></Route>
        <Route exact="true" path="/admin/system/module" element={<Module indicator={props.indicator} history={props.history} />}></Route>
        <Route exact="true" path="/admin/system/menu" element={<MenuList indicator={props.indicator} history={props.history} />}></Route>
        <Route exact="true" path="/admin/system/auth/group" element={<AuthGroup indicator={props.indicator} history={props.history} />}></Route>
        <Route exact="true" path="/admin/system/auth" element={<Auth indicator={props.indicator} history={props.history} />}></Route>



        { // 관리자 페이지
          window.location.pathname.indexOf('/admin') > -1 &&
          <>
            {
              moduleList && moduleList.length > 0 &&
              moduleList.map((item, index) => {
                if( item.isRouter !== 0 && item.isRouter !== '0' ) {
                  var Module = item.module;

                  return (
                    <Route key={'admin_' + item.seq + '_' + index} exact="true" path={item.linkUrl} element={<Module indicator={props.indicator} history={props.history} />}></Route>
                  )
                } else {
                  return '';
                }
              })

            }
          </>
        }

        { // 사용자 페이지
          window.location.pathname.indexOf('/admin') < 0 &&
          <>
            {
              moduleList && moduleList.length > 0 &&
              moduleList.map((item, index) => {
                if( item.isRouter !== 0 && item.isRouter !== '0' ) {
                  var Module = item.module;
                  return (
                    <Route key={'home_' + item.seq + '_' + index} exact="true" path={item.linkUrl} element={<Module />}></Route>
                  )
                } else {
                  return '';
                }
              })
            }
          </>
        }
      </Routes>
    </Suspense>
  );
}

/*****************************************************************************************
 * 설명 : default export 선언
*****************************************************************************************/
export default SiteRouter;

